import { FC, useMemo } from 'react';

import { DateRange } from 'react-day-picker';

import { EMetric } from 'api/useAnalytics';
import { format } from 'date-fns';
import { TooltipProps } from 'recharts';
import { EStatisticType } from 'views/Statistics/StatisticsView.types';

import { TrendsSeparator } from './TrendsSeparator';
interface BarsTooltipProps extends TooltipProps<number, string> {
  dateRange: DateRange;
  comparedDateRange?: DateRange;
  metricType: EStatisticType;
}

export const BarsTooltip: FC<BarsTooltipProps> = ({
  active,
  payload,
  label,
  dateRange,
  comparedDateRange,
  metricType
}) => {
  const formatDateRange = (range?: DateRange) => {
    if (!range?.from || !range?.to) return '';
    return `${format(range.from, 'MMM d, yyyy')} - ${format(range.to, 'MMM d, yyyy')}`;
  };

  const dateString = formatDateRange(dateRange);
  const comparedDateString = formatDateRange(comparedDateRange);

  const data = payload?.[0];
  const comparedData = payload?.[1];

  const percentChange = useMemo(() => {
    if (!data?.value || !comparedData?.value) return null;
    return ((data.value / comparedData.value - 1) * 100).toFixed(2);
  }, [data?.value, comparedData?.value]);

  if (!active || !payload || payload.length === 0 || !data) return null;

  return (
    <div
      className="rounded-md bg-card p-2 shadow-md border border-border text-sm"
      style={{ backgroundColor: 'white', opacity: 1 }}
    >
      <p className="font-medium mb-1 text-base-sidebarRing">{label}</p>
      <TrendsSeparator />
      <div>
        <div>
          <span>{dateString}</span>
        </div>
        <div>
          <span className="text-base-sidebarRing">{`${metricType === EStatisticType.CURRENCY ? '$' : ''}${data.value}`}</span>
        </div>
      </div>
      {comparedData && (
        <>
          <div>
            <div>
              <span>{comparedDateString}</span>
            </div>
            <div>
              <span className="text-base-sidebarRing">
                {`${metricType === EStatisticType.CURRENCY ? '$' : ''}${comparedData.value}`}
              </span>
            </div>
          </div>
          {percentChange !== null && (
            <div>
              <span>{percentChange}% from previous period</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};
